import { Container, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import { Breadcrumb } from '../../components/common/Breadcrumb';
import { EmployeeDictionaryManagement } from '../../features/employee-hub';
import { EmployeeDictionaryType } from '../../models/employeeHub';

export const OperationsPositionsManagement: React.FC = () => {
    return (
        <Container size="xl" py="xl">
            <Stack gap="xl">
                <div>
                    <Breadcrumb
                        items={[
                            { label: 'Operations Panel', href: '/operations' },
                            { label: 'Employee', href: '/operations/employee-hub' },
                            { label: 'Positions', isActive: true },
                        ]}
                    />
                    <Title order={1} size="h2" fw={700}>
                        Positions
                    </Title>
                    <Text c="dimmed" size="lg">
                        Manage employee position codes and display names
                    </Text>
                </div>

                <EmployeeDictionaryManagement
                    type={EmployeeDictionaryType.Position}
                    title="Positions"
                    searchPlaceholder="Search positions..."
                />
            </Stack>
        </Container>
    );
};
